export const PERMISSIONS = {
    Admin: {
        CreateUser: 'Admin_Create_User',
        ResetPassword: 'Admin_Reset_Password',
        GetUserList: 'Admin_Get_User_List',
        AssignRolePermission: 'Admin_Assign_Role_Permission',
        AssignRoleUser: 'Admin_Assign_Role_User',
        GetUserDetail: 'Admin_Get_User_Detail',
        GetPermissionRole: 'Admin_Get_Permission_Role',
        DeleteUser: 'Admin_Delete_User',
        UpdateUser: 'Admin_Update_User',
        Import: 'Admin_Import',
        Export: 'Admin_Export',
    },

    AppRole: {
        Create: 'AppRole_Create',
        GetList: 'AppRole_Get_List',
        Update: 'AppRole_Update',
        Delete: 'AppRole_Delete',
    },

    AttributeDeviceGroup: {
        Create: 'AttributeDeviceGroup_Create',
        GetList: 'AttributeDeviceGroup_Get_List',
        Import: 'AttributeDeviceGroup_Import',
        Delete: 'AttributeDeviceGroup_Delete',
    },

    Customer: {
        GetDetail: 'Customer_Get_Detail',
        Update: 'Customer_Update',
        Create: 'Customer_Create',
        GetList: 'Customer_Get_List',
        Import: 'Customer_Import',
        Export: 'Customer_Export',
        Restore: 'Customer_Restore',
        Delete: 'Customer_Delete',
    },

    DeviceGroup: {
        Restore: 'DeviceGroup_Restore',
        Create: 'DeviceGroup_Create',
        GetList: 'DeviceGroup_Get_List',
        GetDetail: 'DeviceGroup_Get_Detail',
        Delete: 'DeviceGroup_Delete',
        Import: 'DeviceGroup_Import',
        Update: 'DeviceGroup_Update',
        Export: 'DeviceGroup_Export',
    },

    AttributeDeviceValue: {
        Create: 'AttributeDeviceValue_Create',
        GetList: 'AttributeDeviceValue_Get_List',
        Update: 'AttributeDeviceValue_Update',
        Restore: 'AttributeDeviceValue_Restore',
        Delete: 'AttributeDeviceValue_Delete',
    },

    BusinessTripForm: {
        Create: 'BusinessTripForm_Create',
        GetList: 'BusinessTripForm_Get_List',
        GetDetail: 'BusinessTripForm_Get_Detail',
        Update: 'BusinessTripForm_Update',
        Delete: 'BusinessTripForm_Delete',
        Restore: 'BusinessTripForm_Restore',
        Export: 'BusinessTripForm_Export',
    },

    Config: {
        Update: 'Config_Update',
        GetList: 'Config_Get_List',
    },

    CustomerContact: {
        Create: 'CustomerContact_Create',
        GetList: 'CustomerContact_Get_List',
        GetDetail: 'CustomerContact_Get_Detail',
        Update: 'CustomerContact_Update',
        Delete: 'CustomerContact_Delete',
        Restore: 'CustomerContact_Restore',
    },

    CustomerReview: {
        Create: 'CustomerReview_Create',
        GetList: 'CustomerReview_Get_List',
        GetDetail: 'CustomerReview_Get_Detail',
        Update: 'CustomerReview_Update',
        Restore: 'CustomerReview_Restore',
    },

    TaskCheck: {
        GetList: 'TaskCheck_Get_List',
        Create: 'TaskCheck_Create',
        Update: 'TaskCheck_Update',
        Done: 'TaskCheck_Done',
        Cancel: 'TaskCheck_Cancel',
        Declined: 'TaskCheck_Declined',
        GetPersonalList: 'TaskCheck_Get_Personal_List',
        Delete: 'TaskCheck_Delete',
        GetDetail: 'TaskCheck_Get_Detail',
        Export: 'TaskCheck_Export',
    },

    CustomerAccount: {
        Create: 'CustomerAccount_Create',
        Update: 'CustomerAccount_Update',
        Delete: 'CustomerAccount_Delete',
        GetList: 'CustomerAccount_Get_List',
    },

    DeviceType: {
        Export: 'DeviceType_Export',
        Create: 'DeviceType_Create',
        GetList: 'DeviceType_Get_List',
        GetDetail: 'DeviceType_Get_Detail',
        Restore: 'DeviceType_Restore',
        Delete: 'DeviceType_Delete',
        Import: 'DeviceType_Import',
        Update: 'DeviceType_Update',
    },

    DeviceModel: {
        Create: 'DeviceModel_Create',
        GetList: 'DeviceModel_Get_List',
        GetDetail: 'DeviceModel_Get_Detail',
        Restore: 'DeviceModel_Restore',
        Delete: 'DeviceModel_Delete',
        Import: 'DeviceModel_Import',
        Update: 'DeviceModel_Update',
        Export: 'DeviceModel_Export',
    },

    Device: {
        Create: 'Device_Create',
        Update: 'Device_Update',
        GetList: 'Device_Get_List',
        GetDetail: 'Device_Get_Detail',
        Delete: 'Device_Delete',
        Import: 'Device_Import',
        Export: 'Device_Export',
    },

    DeviceSKU: {
        Create: 'DeviceSKU_Create',
        GetList: 'DeviceSKU_Get_List',
        GetDetail: 'DeviceSKU_Get_Detail',
        Delete: 'DeviceSKU_Delete',
        Restore: 'DeviceSKU_Restore',
        Import: 'DeviceSKU_Import',
        Update: 'DeviceSKU_Update',
        Export: 'DeviceSKU_Export',
    },

    ErrorDetail: {
        Create: 'ErrorDetail_Create',
        GetList: 'ErrorDetail_Get_List',
        GetDetail: 'ErrorDetail_Get_Detail',
        Delete: 'ErrorDetail_Delete',
        Update: 'ErrorDetail_Update',
        Export: 'ErrorDetail_Export',
        Import: 'ErrorDetail_Import',
    },

    ErrorDetailTaskCheck: {
        Create: 'ErrorDetailTaskCheck_Create',
        Delete: 'ErrorDetailTaskCheck_Delete',
        GetList: 'ErrorDetailTaskCheck_Get_List',
        GetDetail: 'ErrorDetailTaskCheck_Get_Detail',
        Update: 'ErrorDetailTaskCheck_Update',
    },

    ErrorType: {
        Create: 'ErrorType_Create',
        GetList: 'ErrorType_Get_List',
        GetDetail: 'ErrorType_Get_Detail',
        Delete: 'ErrorType_Delete',
        Update: 'ErrorType_Update',
        Export: 'ErrorType_Export',
        Import: 'ErrorType_Import',
    },

    ExportFile: {
        ExportTemplate: 'ExportFile_Export_Template',
    },

    ImageStore: {
        Create: 'ImageStore_Create',
        GetList: 'ImageStore_Get_List',
        Delete: 'ImageStore_Delete',
    },

    PartCategory: {
        Create: 'PartCategory_Create',
        GetList: 'PartCategory_Get_List',
        GetDetail: 'PartCategory_Get_Detail',
        Restore: 'PartCategory_Restore',
        Delete: 'PartCategory_Delete',
        Import: 'PartCategory_Import',
        Update: 'PartCategory_Update',
        Export: 'PartCategory_Export',
    },

    PartDetail: {
        Create: 'PartDetail_Create',
        GetList: 'PartDetail_Get_List',
        Restore: 'PartDetail_Restore',
        Delete: 'PartDetail_Delete',
        GetDetail: 'PartDetail_Get_Detail',
        Update: 'PartDetail_Update',
    },

    PartGroup: {
        Create: 'PartGroup_Create',
        GetList: 'PartGroup_Get_List',
        GetDetail: 'PartGroup_Get_Detail',
        Restore: 'PartGroup_Restore',
        Delete: 'PartGroup_Delete',
        Import: 'PartGroup_Import',
        Update: 'PartGroup_Update',
    },

    PartInstall: {
        Create: 'PartInstall_Create',
        GetList: 'PartInstall_Get_List',
        GetDetail: 'PartInstall_Get_Detail',
        Delete: 'PartInstall_Delete',
        Update: 'PartInstall_Update',
    },

    PartReceive: {
        Create: 'PartReceive_Create',
        GetList: 'PartReceive_Get_List',
        GetDetail: 'PartReceive_Get_Detail',
        Restore: 'PartReceive_Restore',
        Delete: 'PartReceive_Delete',
        Update: 'PartReceive_Update',
    },

    PartReplace: {
        Create: 'PartReplace_Create',
        GetList: 'PartReplace_Get_List',
        GetDetail: 'PartReplace_Get_Detail',
        Delete: 'PartReplace_Delete',
        Update: 'PartReplace_Update',
    },

    PartRequisition: {
        GetList: 'PartRequisition_Get_List',
        GetDetail: 'PartRequisition_Get_Detail',
        Delete: 'PartRequisition_Delete',
        Update: 'PartRequisition_Update',
    },

    PartSKU: {
        Create: 'PartSKU_Create',
        GetList: 'PartSKU_Get_List',
        Import: 'PartSKU_Import',
        Restore: 'PartSKU_Restore',
        Delete: 'PartSKU_Delete',
        Update: 'PartSKU_Update',
        GetDetail: 'PartSKU_Get_Detail',
    },

    PartSuggestion: {
        Create: 'PartSuggestion_Create',
        GetList: 'PartSuggestion_Get_List',
        GetDetail: 'PartSuggestion_Get_Detail',
        Restore: 'PartSuggestion_Restore',
        Delete: 'PartSuggestion_Delete',
        Update: 'PartSuggestion_Update',
    },

    PartType: {
        Create: 'PartType_Create',
        GetList: 'PartType_Get_List',
        GetDetail: 'PartType_Get_Detail',
        Restore: 'PartType_Restore',
        Delete: 'PartType_Delete',
        Import: 'PartType_Import',
        Update: 'PartType_Update',
    },

    QualityManagement: {
        Create: 'QualityManagement_Create',
        GetList: 'QualityManagement_Get_List',
        Delete: 'QualityManagement_Delete',
        GetDetail: 'QualityManagement_Get_Detail',
        Update: 'QualityManagement_Update',
        Export: 'QualityManagement_Export',
    },

    ReferenceCode: {
        Create: 'ReferenceCode_Create',
        GetList: 'ReferenceCode_Get_List',
        Delete: 'ReferenceCode_Delete',
        Update: 'ReferenceCode_Update',
    },

    ReminderScheduleNotification: {
        GetList: 'ReminderScheduleNotification_Get_List',
        Update: 'ReminderScheduleNotification_Update',
    },

    ReminderSchedule: {
        Create: 'ReminderSchedule_Create',
        Update: 'ReminderSchedule_Update',
        GetList: 'ReminderSchedule_Get_List',
        Delete: 'ReminderSchedule_Delete',
    },

    TaskCheckType: {
        Create: 'TaskCheckType_Create',
        GetList: 'TaskCheckType_Get_List',
        Restore: 'TaskCheckType_Restore',
        Delete: 'TaskCheckType_Delete',
        Update: 'TaskCheckType_Update',
        GetDetail: 'TaskCheckType_Get_Detail',
    },

    TaskRepeat: {
        Create: 'TaskRepeat_Create',
        GetList: 'TaskRepeat_Get_List',
    },

    TaskTemplateDevice: {
        Create: 'TaskTemplateDevice_Create',
        GetList: 'TaskTemplateDevice_Get_List',
        GetDetail: 'TaskTemplateDevice_Get_Detail',
        Delete: 'TaskTemplateDevice_Delete',
        Update: 'TaskTemplateDevice_Update',
    },

    TechnicianLog: {
        Create: 'TechnicianLog_Create',
        GetList: 'TechnicianLog_Get_List',
        GetDetail: 'TechnicianLog_Get_Detail',
        Delete: 'TechnicianLog_Delete',
        Update: 'TechnicianLog_Update',
    },

    TemplateCheck: {
        Create: 'TemplateCheck_Create',
        Update: 'TemplateCheck_Update',
        GetList: 'TemplateCheck_Get_List',
        GetDetail: 'TemplateCheck_Get_Detail',
        Delete: 'TemplateCheck_Delete',
        Restore: 'TemplateCheck_Restore',
    },

    Ticket: {
        Create: 'Ticket_Create',
        CreateByCustomer: 'Ticket_CreateByCustomer',
        Approve: 'Ticket_Approve',
        Done: 'Ticket_Done',
        Cancel: 'Ticket_Cancel',
        GetList: 'Ticket_Get_List',
        Delete: 'Ticket_Delete',
        GetDetail: 'Ticket_Get_Detail',
        Restore: 'Ticket_Restore',
        Update: 'Ticket_Update',
        Export: 'Ticket_Export',
    },

    TicketTemplate: {
        Create: 'TicketTemplate_Create',
        GetList: 'TicketTemplate_Get_List',
        GetDetail: 'TicketTemplate_Get_Detail',
        Delete: 'TicketTemplate_Delete',
        Update: 'TicketTemplate_Update',
    },

    TicketType: {
        Create: 'TicketType_Create',
        GetList: 'TicketType_Get_List',
        Restore: 'TicketType_Restore',
        Delete: 'TicketType_Delete',
        Update: 'TicketType_Update',
        GetDetail: 'TicketType_Get_Detail',
    },

    Translation: {
        Create: 'Translation_Create',
        Update: 'Translation_Update',
        GetList: 'Translation_Get_List',
        Delete: 'Translation_Delete',
        Import: 'Translation_Import',
        Export: 'Translation_Export',
    },

    UsageType: {
        Create: 'UsageType_Create',
        GetList: 'UsageType_Get_List',
        Restore: 'UsageType_Restore',
        Delete: 'UsageType_Delete',
        Update: 'UsageType_Update',
        GetDetail: 'UsageType_Get_Detail',
    },

    ViolationDetail: {
        Create: 'ViolationDetail_Create',
        GetList: 'ViolationDetail_Get_List',
        GetDetail: 'ViolationDetail_Get_Detail',
        Delete: 'ViolationDetail_Delete',
        Update: 'ViolationDetail_Update',
        Import: 'ViolationDetail_Import',
        Export: 'ViolationDetail_Export',
    },

    ViolationDetailTaskCheck: {
        Create: 'ViolationDetailTaskCheck_Create',
        GetList: 'ViolationDetailTaskCheck_Get_List',
        GetDetail: 'ViolationDetailTaskCheck_Get_Detail',
        Delete: 'ViolationDetailTaskCheck_Delete',
        Update: 'ViolationDetailTaskCheck_Update',
        Export: 'ViolationDetailTaskCheck_Export',
    },

    ViolationType: {
        Create: 'ViolationType_Create',
        GetList: 'ViolationType_Get_List',
        GetDetail: 'ViolationType_Get_Detail',
        Delete: 'ViolationType_Delete',
        Update: 'ViolationType_Update',
    },

    StaffCoordination: {
        Create: 'StaffCoordination_Create',
        GetList: 'StaffCoordination_Get_List',
    },
};
